// extracted by mini-css-extract-plugin
export var attribution = "_8w-4";
export var authorName = "_8w-5";
export var quote = "_8w-3";
export var testimonial = "_8w-2";
export var trustedBy = "_8w-0";
export var trustedByLabel = "_8w-1";